import React from 'react';

export const Arrow = () => (
  <svg width="12" height="5" viewBox="0 0 12 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.1919 4.64002C8.29857 4.36268 8.4159 4.10668 8.5439 3.87202C8.6719 3.62668 8.8159 3.39735 8.9759 3.18402H0.399902V1.87202H8.9759C8.82657 1.65868 8.6879 1.43468 8.5599 1.20002C8.4319 0.954683 8.31457 0.693349 8.2079 0.416016H9.4239C10.0852 1.19468 10.8106 1.78668 11.5999 2.19202V2.88002C10.8106 3.26402 10.0852 3.85068 9.4239 4.64002H8.1919Z"
      fill="#05868E"
    />
  </svg>
);
